import { Skeleton } from '@chakra-ui/react';
import { L2_PATHS } from 'Deer/constants/routes';
import { NextCheckInIntent } from 'Deer/intent/CheckIns/NextCheckInIntent';
import { CheckInsIntentDropdown } from 'Deer/intent/CheckIns/components/CheckInsIntentDropdown';
import { CurrentCheckInsMetaFilter } from 'Deer/intent/CheckIns/components/CurrentCheckInsMetaFilter';
import { Layout } from 'Deer/intent/components/Layout/Layout';

import { useGetCurrentCheckIns } from '../data';

const NEXT_CHECK_INS_BREADCRUMBS = {
  items: [
    {
      label: 'Me',
      to: L2_PATHS['my-data'].overview,
    },
  ],
  page: {
    label: 'Check-ins',
    to: '',
  },
};

export const NextCheckIn = () => {
  const { data: currentCheckInData, isLoading, isError } = useGetCurrentCheckIns();

  if (isError) return null;

  const metaFilter = isLoading ? (
    <Skeleton w="311px" height="30px" mt="12px" borderRadius="9999px" />
  ) : (
    <CurrentCheckInsMetaFilter dueDate={currentCheckInData.dueDateTS} />
  );

  return (
    <Layout Filters={<CheckInsIntentDropdown breadcrumbs={NEXT_CHECK_INS_BREADCRUMBS} MetaFilter={metaFilter} />}>
      {currentCheckInData && <NextCheckInIntent currentCheckInData={currentCheckInData} />}
    </Layout>
  );
};
